import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ScheduleService } from '../schedule-service';
import { ScheduleItem } from '../schedule.types';
import { LoginService } from '@intranet/modules/login';
import { AlertDialog } from '@intranet/shared/alert/alert-dialog.component';
import { AddScheduleDialog } from '../add-schedule-dialog/add-schedule-dialog.component';

@Component({
    selector: 'app-toggl-schedule',
    templateUrl: './toggl-schedule.component.html',
    styleUrls: ['./toggl-schedule.component.scss']
})
export class TogglScheduleComponent implements OnInit {

    constructor(
        private scheduleService: ScheduleService,
        private _dialog: MatDialog,
        private _loginService: LoginService
    ) { }


    schedules: ScheduleItem[] = [];
    isAdmin: boolean = false;

    showSchedules() {
        return this.schedules.length > 0;
    }

    ngOnInit(): void {
        this.isAdmin = this._loginService.checkAuth(['admin']);
        this.loadSchedules();
    }

    loadSchedules(): void {
        this.scheduleService.getSchedule().subscribe({
            next: (r) => {
                if (r.success) {
                    this.schedules = r.schedules;
                }
            }
        });
    }

    openAddDialog(): void {
        const dialogRef = this._dialog.open(AddScheduleDialog, {
            width: '480px',
        });

        dialogRef.afterClosed().subscribe((created) => {
            if (created) {
                this.loadSchedules();
            }
        });
    }

    onDelete(schedule: ScheduleItem, event: MouseEvent): void {
        event.stopPropagation();

        const confirmRef = this._dialog.open(AlertDialog, {
            width: '320px',
            data: {
                title: 'Are you sure?',
                message: `You are about to delete the scheduled "${schedule.jobType}" task. Are you sure?`,
                confirm: true,
                confirmTitle: 'Yes',
            },
        });

        confirmRef.afterClosed().subscribe((confirmed) => {
            if (!confirmed) {
                return;
            }

            this.scheduleService.deleteSchedule(schedule.jobScheduleId).subscribe({
                next: (result) => {
                    if (result.success) {
                        this.schedules = this.schedules.filter(
                            (s) => s.jobScheduleId !== schedule.jobScheduleId
                        );
                    } else {
                        this._dialog.open(AlertDialog, {
                            width: '320px',
                            data: {
                                title: 'Delete Failed',
                                message: result.error || 'Something went wrong deleting the scheduled task.',
                                confirm: false,
                                confirmTitle: '',
                            },
                        });
                    }
                },
                error: () => {
                    this._dialog.open(AlertDialog, {
                        width: '320px',
                        data: {
                            title: 'Delete Failed',
                            message: 'Something went wrong deleting the scheduled task.',
                            confirm: false,
                            confirmTitle: '',
                        },
                    });
                },
            });
        });
    }

}
